export default {
  title: "صفحه پیدا نشد",
  body: "متاسفیم 😔، چیزی که دنبالش بودید پیدا نکردیم.",
  devHint: "برای ساخت صفحه، این مسیر را ببینید:",
  goHome: "بازگشت به خانه",
};
